import { inject } from '@angular/core';
import { ClaimMenuCountsService } from './shared/claim-menu-counts.service';

/**
 * App-shell hooks for claims experience v2. Lives in the routing layer
 * (`*.routes*.ts`) because the app shell may import that layer but not a
 * feature directly.
 *
 * Starts the sidenav "needs your action" counts. Call from an injection
 * context (the app component's constructor); does nothing while the flag is
 * off.
 */
export function startClaimMenuCounts(): void {
  inject(ClaimMenuCountsService).start();
}
